import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f356c7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CustomDeleted" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {getListData} from "@/service/main/system";
import {useStore} from "@/store";
import dayjs from "dayjs";
import {initEmptyParam} from "@/hooks/useInitParam";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomDeleted',
  setup(__props) {

initEmptyParam()
const store = useStore()
const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})
  const roleItem = searchFormConfig.formItems.find((item) => item.field === 'corPid')
  roleItem!.options = roleData.map((item: any) => {
    return {title: item.name, value: item.id}
  })
}
getCompanyList()

const getUsedBy = async () => {
  let userList = await getListData('/main/enterpriseWechat/dingUser/listAll', {});
  const userOptions = userList.map((item: any) => {
    return {title: item.userName, value: item.userName};
  })
  const usedByItem = searchFormConfig.formItems.find(item => item.field === 'usedBy');
  usedByItem!.options = userOptions;
}
getUsedBy()

const queryParam = {
  queryDate: dayjs().format('YYYY-MM'),
  days: 5,
  pageNo: 1,
  pageSize: 10
}
store.commit('system/changeQueyryInfo', queryParam)
const resetCb = () => {
  return queryParam
}

const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick, handleSummaryBtnClick] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "customDeleted",
      downFilename: "客户删除统计详情.xlsx",
      summaryFilename: "客户删除统计汇总.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick),
      onSummaryBtnClick: _unref(handleSummaryBtnClick)
    }, null, 8, ["contentTableConfig", "onDownBtnClick", "onSummaryBtnClick"])
  ]))
}
}

})